<template lang="html">
  <div class="list-card-person">
    <Carousel :settings="settings" :breakpoints="breakpoints">
      <Slide v-for="(item, idx) in data" :key="idx">
        <CardPersonInfo
          :imageURL="baseUrlStorage + item.image"
          :autor="item.autor"
          :rol="item.rol"
          data-aos="fade-up"
          :data-aos-duration="item.time"
        />
      </Slide>
      <template #addons>
        <Pagination />
      </template>
    </Carousel>
  </div>
</template>
<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination } from "vue3-carousel";

import CardPersonInfo from "./CardPersonInfo.vue";

export default {
  inject: ["baseUrlStorage"],
  props: {
    data: Array,
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    CardPersonInfo,
  },
  data() {
    return {
      persons: [
        {
          imageURL: "https://i.ibb.co/Ky85qCy/Card-Person-Info.png",
          autor: "Karla Lopez",
          rol: "Comunity Manager",
          time: "1000",
        },
        {
          imageURL: "https://i.ibb.co/Ky85qCy/Card-Person-Info.png",
          autor: "Fernanda Huanca",
          rol: "Tecnique Enginer",
          time: "1300",
        },
        {
          imageURL: "https://i.ibb.co/Ky85qCy/Card-Person-Info.png",
          autor: "Sofia Moretti",
          rol: "Comunnity Manager",
          time: "1500",
        },
        {
          imageURL: "https://i.ibb.co/Ky85qCy/Card-Person-Info.png",
          autor: "Lopecia Marquez",
          rol: "Developer React",
          time: "1700",
        },
        {
          imageURL: "https://i.ibb.co/Ky85qCy/Card-Person-Info.png",
          autor: "YeferDon",
          rol: "Software Enginer",
        },
      ],
      settings: {
        itemsToShow: 1,
        snapAlign: "start",
      },
      breakpoints: {
        0: {
          itemsToShow: 1,
        },
        700: {
          itemsToShow: 2,
        },
        1000: {
          itemsToShow: 3,
          snapAlign: "start",
        },
        1400: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
};
</script>
<style lang="css">
.list-card-person .carousel__track {
  align-items: flex-start;
}
.list-card-person .carousel__pagination-item {
  margin-top: 40px;
}
.list-card-person .carousel__pagination-item button {
  min-width: 15px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background: #33647e;
  opacity: 0.3;
}
.list-card-person
  .carousel__pagination-item
  button.carousel__pagination-button--active {
  opacity: 1;
}
</style>
